import React from 'react';

import LinearProgress from '@mui/material/LinearProgress';
import { Box, Grid } from '@sunwisesoftware/sunwise-ui';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import EmptyState from 'common/components/EmptyState';

import EmptyProposals from 'resources/EmptyProposals.svg?react';

import ProposalTable from './ProposalTable';

const Content = ({
    filterData,
    handleClickCreate,
    handleClickDuplicate,
    isFetching,
    proposals,
    showEmptyState,
}) => {
    const { t } = useTranslation();

    if (isFetching)
        return (
            <Box height={460}>
                <LinearProgress />
            </Box>
        );

    if (!isFetching && showEmptyState.show)
        return (
            <Grid container justifyContent="center">
                <Grid size="grow">
                    {showEmptyState?.status === 'active' ? (
                        <EmptyState
                            caption={t(
                                'Here you will see all the proposals of the project. Start creating one!',
                            )}
                            classNameCard="border-0"
                            onClick={() =>
                                handleClickCreate(filterData?.projectId)
                            }
                            srcSvg={<EmptyProposals />}
                            sxCard={{ border: 0, boxShadow: 'none' }}
                            textButton={t('Create')}
                            title={t('This project has no proposals')}
                        />
                    ) : (
                        <EmptyState
                            srcSvg={<EmptyProposals />}
                            sxCard={{ border: 0, boxShadow: 'none' }}
                            title={t('This project has no archived proposals')}
                        />
                    )}
                </Grid>
            </Grid>
        );

    return (
        <ProposalTable
            filterData={filterData}
            handleClickDuplicate={handleClickDuplicate}
            proposals={proposals}
        />
    );
};

Content.propTypes = {
    filterData: PropTypes.object,
    handleClickCreate: PropTypes.func,
    handleClickDuplicate: PropTypes.func,
    isFetching: PropTypes.bool,
    proposals: PropTypes.array,
    showEmptyState: PropTypes.object,
};

export default Content;
